import { Lists } from 'types'

const tables: Lists = {
  loaded: false,
  title: 'Order book',
  headers: {
    title: 'price',
    title1: 'amount',
    title2: 'total',
  },
  url: 'wss://stream.binance.us:9443/ws',
  lists: {
    XPIVX: {
      title: 'PIVX',
      inc: [0.0000001, 0.0001, 0.0002],
      ticker: 0.0000001,
      pair: 'PIVXBTC',
    },
    XBTC: {
      title: 'BTC',
      inc: [0.05, 0.1, 0.25],
      ticker: 0.05,
      pair: 'XBTUSD',
    },
    XETH: {
      title: 'ETH',
      inc: [0.05, 0.1, 0.25],
      ticker: 0.05,
      pair: 'ETHUSDT',
    },
  },
}

export default tables
